import { BlueShieldCheckmark as BlueShieldCheckmarkIcon } from 'phosphor-icons';
import { c } from '../../../utils/tailwind-merge';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '../../atoms/Tooltip/TooltipRadix';
import { RichText } from '../RichText';
import { CertifiedPublisherProps } from './CertifiedPublisher.types';

export const CertifiedPublisher = ({
  microcopy,
  className = '',
}: CertifiedPublisherProps) => {
  return (
    <Tooltip>
      <TooltipTrigger
        aria-label={microcopy.icon}
        className={c('p-0.5', className)}
        data-test="certified-publisher-icon"
      >
        <BlueShieldCheckmarkIcon />
      </TooltipTrigger>

      <TooltipContent className="z-[100]">
        <RichText
          html={microcopy.description}
          className="text-gray-400 text-sm [&_p]:mb-0"
        />
      </TooltipContent>
    </Tooltip>
  );
};
